import { getUrls } from '@shared/utils/config/environment';
import { determineVMType } from '@shared/utils/validation/network-validation';
import { BlockchainType } from '@shared/types/services/enums';
export default async function withdrawWrapper({
  network,
  tokenAddress,
  tokenAmount,
  cloudWallet,
  receiver,
  permitBatchDetails,
  permitSignatures,
  PKP
}) {
  const baseUrl = '/api/wrapper?target=';
  const geniusQuotingEngineUrl = baseUrl + getUrls().QUOTER_URL;
  const url = geniusQuotingEngineUrl + '/transfer/withdraw';
  console.log('withdrawQuote:sending request', {
    url
  });
  try {
    const vmType = determineVMType(network);
    const from = vmType === BlockchainType.EVM || vmType === BlockchainType.SVM ? cloudWallet : PKP.suiAddress;
    const to = receiver;
    const token = tokenAddress;
    const amount = tokenAmount;
    const permitBatch = permitBatchDetails[0] ? {
      permitBatch: permitBatchDetails[0],
      signature: permitSignatures[0]
    } : undefined;
    const response = await fetch(url, {
      method: 'POST',
      body: JSON.stringify({
        from,
        to,
        token,
        amount,
        network,
        permitBatch
      })
    });
    const data = await response.json();
    if (data === null || data === void 0 ? void 0 : data.error) {
      throw new Error(data.error);
    }
    return data;
  } catch (e) {
    console.error('[withdrawWrapper]', e);
    return {
      error: e.message
    };
  }
}